import { useParams, useSearchParams } from "react-router-dom";
import { DashboardLayout } from "src/components/dashboard";
import { useEffect } from "react";
import AdsLanding from "./adsLanding";
import AdsCategory from "./adsCategory";

const AdsPage = () => {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    document.title = "Ads Management Page";
  }, []);
  const adType = searchParams.get("type");
  if (adType && adType?.length > 1) {
    return (
      <DashboardLayout>
        <AdsCategory />
      </DashboardLayout>
    );
  }
  return (
    <DashboardLayout>
      <AdsLanding />
    </DashboardLayout>
  );
};

export default AdsPage;
